import { PagePath } from '../enums/page-path.enum';

export interface MedicarePlanIds {
  contractId: string;
  planId: string;
  segmentId: string;
}

export enum DeepLinkingParamKey {
  ZIPCODE = 'ZIPCODE',
  ZIP = 'ZIP',
  COUNTYFIPS = 'COUNTYFIPS',
  FIPS = 'FIPS',
  PLANTYPE = 'PLANTYPE',
  PLANID = 'PLANID',
  PLAN = 'PLAN',
  TFN = 'TFN'
}

export class DeepLinkingParams {
  ZIPCODE?: string;
  ZIP?: string;
  COUNTYFIPS?: string;
  FIPS?: string;
  PLANTYPE?: string;
  PLANID?: string;
  PLAN?: string;
  TFN?: string;
}

export const PassParameterPages = [PagePath.HOME, PagePath.SELECT_PLAN, PagePath.ACCOUNT_PRESCRIPTIONS];
